module.exports = "<things-list></things-list>\r\n<areas-edit></areas-edit>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/pages/things/things.component.html
// module id = ../../../../../src/app/pages/things/things.component.html
// module chunks = main